import axios from 'axios'
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Input, FormGroup, Label, Button } from 'reactstrap'
import { useNavigate } from "react-router-dom"
import { useSelector } from 'react-redux'
const CreateRole = () => {
    const [formData, setFormData] = useState({
        name: "",
        status: 1
    })
    const [errors, setErrors] = useState({})
    const navigate = useNavigate()
    const {
        AuthReducer: { auth }
      } = useSelector((state) => state);
    const inputHandler = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
    }

    const handlSubmit = () => {
        const form = new FormData();
        for (const key in formData) {
            form.append([key], formData[key]);
        }
        axios.post(`/api/admin/v1/role-create`, form, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${auth?.token}`,
            },
        })
            .then((res) => {
                toast.success("Role Created Successfully")
                navigate(-1);
            }).catch((err) => {
                toast.error(err.response.data.message)
                setErrors(err.response.data)
            })
    }
    return (
        <div>
            <div className='row my-3'>
                <div className='col-md-12'>
                    <h5 className='text-white'>Add Role</h5>
                </div>
            </div>
            <div className='bg-white px-3 py-4 rounded-2  my-4' >
                <div className="row">
                    <div className="col-md-4 offset-md-4">
                        <FormGroup>
                            <Label>Role Name <span className="text-danger fs-4">*</span></Label>
                            <Input value={formData.name} invalid={Boolean(errors?.name)} onChange={inputHandler} name="name" />
                            <p className='d-block text-danger' >
                                {errors?.name}
                            </p>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-4">
                        <Button color='primary' onClick={handlSubmit}>
                            Submit
                        </Button>
                        <Button className='ms-3' onClick={() => navigate(-1)}  >
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateRole